import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useDispatch } from "react-redux";

import cssClasses from "./BenefitPlan.module.css";
import actions from "../../Redux Store/actions";

import BasicBrokerage from "./BasicBrokerageConfig";
import PopBenefitPlan from "./ProjectOperatingPlan";
import AopBenefitPlan from "./AOPConfigurations";

export default function BenefitPlan() {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState("BASIC_BROKERAGE");

  useEffect(() => {
    dispatch(actions.activeMenu("benefitplan"));
  }, [dispatch]);

  return (
    <div className="pageWrapper">
      
      {/* HEADER */}
      <div
        className={cssClasses.wrapperHeader}
        style={{ margin: "2rem 0" }}
        
      >
        <div>
          <div className={cssClasses.headerTitle}>Benefit Plan</div>
          <div className={cssClasses.headerSubTitle}>
            Manage your benefit plans here.
          </div>
        </div>
      </div>

      {/* STICKY TABS WRAPPER */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "#fff",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={(e, val) => setTabValue(val)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Benefit plan tabs"
          sx={{
            borderBottom: "1px solid #EAECF0",
            minHeight: "58px",

            "& .MuiTabs-indicator": {
              backgroundColor: "#175CD3",
              height: "2px",
            },

            "& .Mui-selected": {
              color: "#175CD3 !important",
            },
          }}
        >
          <Tab
            label="Basic Brokerage"
            value="BASIC_BROKERAGE"
            sx={{
              fontFamily: "Inter-Medium !important",
              fontWeight: 500,
              fontSize: "1.5rem",
              lineHeight: "2rem",
              textTransform: "none",
              minHeight: "48px",
              padding: "12px 8px",
            }}
          />

          <Tab
            label="POP"
            value="ADDITIONAL_POP"
            sx={{
              fontFamily: "Inter-Medium !important",
              fontWeight: 500,
              fontSize: "1.5rem",
              lineHeight: "2rem",
              textTransform: "none",
              minHeight: "48px",
              padding: "12px 16px",
            }}
          />

          <Tab
            label="AOP"
            value="ADDITIONAL_AOP"
            sx={{
              fontFamily: "Inter-Medium !important",
              fontWeight: 500,
              fontSize: "1.5rem",
              lineHeight: "2rem",
              textTransform: "none",
              minHeight: "48px",
              padding: "12px 16px",
            }}
          />
        </Tabs>
      </Box>

      {/* TAB CONTENT */}
      <Box sx={{ mt: 3 }}>
        {tabValue === "BASIC_BROKERAGE" && <BasicBrokerage />}
        {tabValue === "ADDITIONAL_POP" && <PopBenefitPlan />}
        {tabValue === "ADDITIONAL_AOP" && <AopBenefitPlan />}
      </Box>
    </div>
  );
}
